import axios from 'axios';

const paymentService = {
    setUserPayment,
    deleteUserPayment,
    getUserPayment,
    createPaymentToken,

    // yaad sarig
    createTokenFromTransaction,
    createPaymentLandingPage,

    // creditguard (spec 000141)
    createTokenFromCreditGuardRedirect
};
async function setUserPayment(user) {
    return await axios.post('/payment/UpdatePayment', user);
}

async function deleteUserPayment(value) {
    return await axios.delete('/payment/', value);
}

async function getUserPayment() {
    return await axios
        .get('/payment')
}
async function createPaymentToken() {
    return await axios
        .get('/payment/createToken/')
}

// Yaad Sarig Function

async function createTokenFromTransaction(data) {
    return await axios.post(`/payment/CreateTokenFromTransaction`, data)
}

async function createPaymentLandingPage(data) {
    return await axios.get(`/payment/CreatePaymentLandingPage`)
}

// CreditGuard (spec 000141) — posts the hosted-page redirect params for server-side responseMac verification + token save.
async function createTokenFromCreditGuardRedirect(data) {
    return await axios.post(`/payment/CreateTokenFromCreditGuardRedirect`, data)
}


export default paymentService;
